import {Route, Routes} from "react-router-dom";
import Home from "./Home";
import CircleBrelok from "./CircleBrelok";
import Contact from "./Contact";
import React, {useState} from "react";
import OpletenieBousin from "./OpletenieBousin";
import KvadratStolbik from "./KvadratStolbik";
import HistoryBicer from "./HistoryBicer";
import Articles from "./Articles";
import Solnishko from "./Solnishko";
import Krestik from "./Krestik";
import Shnur from "./Shnur";
import Vetochka from "./Vetochka";
import Podstavka from "./Podstavka";
import BrelokiAksessuary from "./BrelokiAksessuary";
import Braslet from "./Braslet";
import Bousi from "./Bousi";
import Otdelka from "./Otdelka";
import Cvetochki from "./Cvetochki";
import Ukrasheniya from "./Ukrasheniya";
import Vosmerka from "./Vosmerka";

const PagesSharp = () => {
    return (<div className="content">
        <Routes location={window.location}>
            <Route path="/" element={<Home/>}/>
            <Route path="/articles" element={<Articles/>}/>
            <Route path="/ukrasheniya" element={<Ukrasheniya/>}/>
            <Route path="/braslet" element={<Braslet/>}/>
            <Route path="/bousi" element={<Bousi/>}/>
            <Route path="/otdelka" element={<Otdelka/>}/>
            <Route path="/cvetochki" element={<Cvetochki/>}/>
            <Route path="/breloki-aksessuary" element={<BrelokiAksessuary/>}/>
            <Route path="/podstavka" element={<Podstavka/>}/>
            <Route path="/vetochka" element={<Vetochka/>}/>
            <Route path="/krestik" element={<Krestik/>}/>
            <Route path="/shnur" element={<Shnur/>}/>
            <Route path="/solnishko" element={<Solnishko/>}/>
            <Route path="/history" element={<HistoryBicer/>}/>
            <Route path="/kvadrat-stolbik" element={<KvadratStolbik/>}/>
            <Route path="/opletenie-bousin" element={<OpletenieBousin/>}/>
            <Route path="/circle-brelok" element={<CircleBrelok/>}/>
            <Route path="/vosmerka" element={<Vosmerka/>}/>
            <Route path="/contact" element={<Contact/>}/>
        </Routes>

    </div>)
}

export default PagesSharp;